// extracted by mini-css-extract-plugin
export var container = "index-module--container--5oUpm";
export var footer = "index-module--footer--iu+-8";
export var footerEmail = "index-module--footer-email--WpmlL";
export var footerRights = "index-module--footer-rights--xtVK3";